import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [NgClass],
  template: `
    @if (open) {
      <div class="modal d-block" tabindex="-1">
        <div class="modal-dialog" [ngClass]="dialogClass">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ title }}</h5>
              <button type="button" class="btn-close" (click)="closed.emit()"></button>
            </div>
            <div class="modal-body">
              <ng-content></ng-content>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show"></div>
    }
  `,
})
export class DialogComponent {
  @Input() open = false;
  @Input() title = 'Dialog';
  @Input() dialogClass = '';
  @Output() closed = new EventEmitter<void>();
}
